import classNames from 'classnames';
import { ProductContext, ProductTile } from 'product';
import React, { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import './ProductGrid.scss';
// Load up to 12 elements (3 rows on desktop, 4 on mobile) in advance
const CHUNK_SIZE = 12;
function ProductGrid({ products, columnsOnDesktop = 4, className }) {
    const classes = classNames({
        'product-grid': true,
        'product-grid--three-columns-on-desktop': columnsOnDesktop === 3,
        [className]: className,
    });
    const productContext = useContext(ProductContext);
    const dispatch = useDispatch();
    const isBusiness = document.location.pathname.startsWith('/bedrift');
    const selectedProduct = useSelector((state) => state.businessInfo.selectedProduct);
    const isSubscriptionMode = useSelector((state) => state.subscription.isSubscriptionMode);
    const [loadedTiles, setLoadedTiles] = useState([]);
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });
    function renderTile(product, i) {
        return (React.createElement(ProductTile, { key: product.id, product: product, variant: isBusiness && (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id) === product.id
                ? 'variant-selected'
                : `variant-${(i % 5) + 1}`, shrinkOnMobile: true, isBusiness: isBusiness, isSubscriptionMode: isSubscriptionMode }));
    }
    function loadNextBatch(prevTiles) {
        const newTiles = products
            .slice(prevTiles.length, prevTiles.length + CHUNK_SIZE)
            .map(renderTile);
        setLoadedTiles(prevTiles.concat(newTiles));
    }
    useEffect(() => loadNextBatch([]), [products]);
    useEffect(() => {
        if (inView) {
            dispatch({ type: 'VIEW_ITEM_LIST', payload: { products, productContext } });
        }
    }, [inView]);
    return (React.createElement("div", { ref: ref },
        React.createElement(InfiniteScroll, { dataLength: loadedTiles.length, hasMore: loadedTiles.length < products.length, loader: null, next: () => loadNextBatch(loadedTiles), className: classes, children: loadedTiles, scrollThreshold: 0.7 })));
}
export default ProductGrid;
